// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Navigation]);

document.addEventListener('DOMContentLoaded', function () {

    /* -------------------------------------------
    HERO SLIDER INIT
    ------------------------------------------- */
    let hero_slider_blocks = document.querySelectorAll('#swiper-home-hero');

    hero_slider_blocks.forEach(function (hsb, index) {

        // let slide_div = hsb.querySelector('.swiper');
        const slide_div = hsb;

        // only proceed if we have found a matching div
        if (slide_div !== null) {

            let slides_per_view = slide_div.getAttribute('data-per-view') ? parseInt(slide_div.getAttribute('data-per-view')) : 1;
            let swiper_id = slide_div.getAttribute('data-id');

            console.log('swiper_id', swiper_id);

            const swiper = new Swiper('#swiper-' + swiper_id, {
                slidesPerView: slides_per_view,
                spaceBetween: 0,

                modules: [],

                navigation: {
                    nextEl: '#swiper-' + swiper_id + ' .hs-arrow-right',
                    prevEl: '#swiper-' + swiper_id + ' .hs-arrow-left',
                },
            });

            // swiper.init();

        }

    });



    /* -------------------------------------------
   KOMMENDE SHOWS
   ------------------------------------------- */
    let shows_slider_blocks = document.querySelectorAll('.swiper-shows');

    shows_slider_blocks.forEach(function (hsb, index) {

        console.log('shows_slider_blocks INIT: ', hsb);

        // let slide_div = hsb.querySelector('.swiper');
        const slide_div = hsb;

        // only proceed if we have found a matching div
        if (slide_div !== null) {

            let slides_per_view = slide_div.getAttribute('data-per-view') ? parseInt(slide_div.getAttribute('data-per-view')) : 1;
            let swiper_id = slide_div.getAttribute('data-id');

            console.log('swiper_id', swiper_id);

            const swiper = new Swiper('#swiper-' + swiper_id + ' .swiper', {
                slidesPerView: 1,
                watchSlidesProgress: true,

                modules: [],

                spaceBetween: 0,
                // spaceBetween: 20,

                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 0,
                        // spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                        // spaceBetween: 60,
                    },
                },

                navigation: {
                    nextEl: '#swiper-' + swiper_id + ' .ss-arrow-right',
                    prevEl: '#swiper-' + swiper_id + ' .ss-arrow-left',
                },
            });

            console.log('#swiper-' + swiper_id + ' .ss-arrow-right');

        }

    });




    /* -------------------------------------------
   EVENT: IMAGE SLIDER
   ------------------------------------------- */
    let event_image_slider = document.querySelectorAll('.logo-event-image-swiper .swiper');

    event_image_slider.forEach(function (hsb, index) {

        console.log('event_image_slider INIT: ', hsb);

        // let slide_div = hsb.querySelector('.swiper');
        const slide_div = hsb;

        // only proceed if we have found a matching div
        if (slide_div !== null) {

            let slides_per_view = slide_div.getAttribute('data-per-view') ? parseInt(slide_div.getAttribute('data-per-view')) : 1;
            let swiper_id = slide_div.getAttribute('data-id');

            console.log('swiper_id', swiper_id);

            const swiper = new Swiper('#swiper-' + swiper_id + ' .swiper', {
                slidesPerView: slides_per_view,
                watchSlidesProgress: true,

                modules: [],

                spaceBetween: 30,

                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                },

                navigation: {
                    nextEl: '#swiper-' + swiper_id + ' .ss-arrow-right',
                    prevEl: '#swiper-' + swiper_id + ' .ss-arrow-left',
                },
            });

        }

    });



}, false);